import { ProductThumbnail } from 'components/ProductThumbnail/ProductThumbnail';
import { useIsMobile } from 'hooks/useIsMobile';
import React, { FC } from 'react';
import { SelectableProduct } from 'types/selectable-product';
import styles from '../SelectProductsStep.scss';

const SKELETON_ITEM_COUNT = 8;

interface ProductPickerGridProps {
  products: SelectableProduct[];
  selectedProductIds: string[];
  onToggle: (product: SelectableProduct) => void;
  maxSelectedProducts: number;
  isLoading?: boolean;
}

export const ProductPickerGrid: FC<ProductPickerGridProps> = ({
  products,
  selectedProductIds,
  onToggle,
  maxSelectedProducts,
  isLoading = false,
}) => {
  const isMobile = useIsMobile();

  if (isLoading) {
    return (
      <div className={styles.selectProductsStepOptions} aria-busy="true" aria-live="polite">
        {[...Array.from({ length: SKELETON_ITEM_COUNT })].map((_, index) => (
          <div key={index} className={styles.selectProductsStepOptionsItem}>
            <div className={styles.selectProductsStepOptionsItemSkeleton} />
            <div className={styles.selectProductsStepOptionsItemLabel}>
              <div className={styles.selectProductsStepOptionsItemLabelSkeleton} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={styles.selectProductsStepOptions}>
      {products.map((product) => {
        const isSelected = selectedProductIds.includes(product.id);
        const image = isSelected && isMobile ? product.mockupImageUrl : product.imageUrl;

        return (
          <div key={product.id} className={styles.selectProductsStepOptionsItem}>
            <ProductThumbnail
              imageUrl={image}
              name={product.name}
              selected={isSelected}
              disabled={selectedProductIds.length >= maxSelectedProducts && !isSelected}
              onClick={() => onToggle(product)}
            />
          </div>
        );
      })}
    </div>
  );
};
